import { QueryResult } from '@apollo/client'
import { useEffect } from 'react'

/**
 * we can't get a signal from the context saying that it's refetch method completed,
 * or was fired. the best we can do is listen to the loading state.
 *
 * in theory... when the loading state changes, and is, we ignore. when it changes
 * again, and isn't... it probably means
 */
export function useRefetchWithParent<
  T extends QueryResult<Data, Variables>,
  Data = any,
  Variables = any
>({
  parentLoading = false,
  refetch,
  callback,
}: UseRefetchWithParentOptions<T, Data, Variables>) {
  useEffect(() => {
    if (parentLoading) return
    callback?.()
    refetch()
    /**
     * do not listen to refetch or callback in useEffect to prevent an infinite reload
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parentLoading])
}

type UseRefetchWithParentOptions<
  T extends QueryResult<Data, Variables>,
  Data = any,
  Variables = any
> = Pick<T, 'refetch'> & {
  parentLoading?: boolean
  callback?: () => void
}
